<template>
  <div>
    <b-breadcrumb :items="items" active-class="active-page"></b-breadcrumb>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      const raw = this.$store.getters[
        `breadcrumb/${this.$route.meta.breadcrumb}`
      ] || [];
      // Clone defensively without assuming JSON-serializable value
      const labels = Array.isArray(raw) ? raw.map(item => ({ ...item })) : [];
      for (let i = 0; i < labels.length; i++) {
        labels[i].text = this.$t(`${labels[i].text}`);
      }
      return labels;
    }
  }
};
</script>

<style scoped>
a {
  color: #3c4b64;
}

.breadcrumb {
  margin: 0;
  border: none;
}

.breadcrumb-item.active {
  color: #186AE4;
}
</style>
